import { render, staticRenderFns } from "./beta_users.vue?vue&type=template&id=15662987&scoped=true&"
import script from "./beta_users.vue?vue&type=script&lang=js&"
export * from "./beta_users.vue?vue&type=script&lang=js&"
import style0 from "./beta_users.vue?vue&type=style&index=0&id=15662987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15662987",
  null
  
)

export default component.exports